import { AuthenticationProvider } from "@/common/providers/authentication";
import { User } from "@/features/authentication/models/user";
import { redirect, RouteObject } from "react-router-dom";
import { HomeRoute } from "../home/route";
import LoginPage from "./pages/login";
import SignUpPage from "./pages/sign-up";
import ResetRequiredPage from "./pages/reset-required";

async function loginLoader() {
	const user = window.localStorage.getItem("user");

	if (!user) {
		return;
	}

	const navUser = JSON.parse(user) as User;

	if (!navUser || !navUser.emailVerified) {
		return;
	}

	AuthenticationProvider.signin(navUser);
	return redirect(HomeRoute);
}

const AuthenticationPath = "/authentication";
export const LoginRoute = AuthenticationPath + "/login";
export const SignUpRoute = AuthenticationPath + "/signup";
export const ResetRequiredRoute = AuthenticationPath + "/reset-required";

const route: RouteObject = {
	path: AuthenticationPath,
	children: [
		{
			path: LoginRoute,
			loader: loginLoader,
			Component: LoginPage,
		},
		{
			path: SignUpRoute,
			Component: SignUpPage,
		},
		{
			path: ResetRequiredRoute,
			Component: ResetRequiredPage,
		},
	],
};

export default route;
